import PropTypes from 'prop-types';
import HelpModal from './HelpModal';
import { DetailsPill } from './SettingDetails';
import './SelectSetting.scss';

const SelectSetting = ({
  name,
  label,
  value,
  options,
  onChange,
  helpTitle,
  helpDescription,
  disabled = false,
  description,
  details,
  children,
}) => {
  return (
    <div className={name}>
      <span className="toggle-switch-label">{label}</span>
      {helpTitle && helpDescription && <HelpModal title={helpTitle} description={helpDescription} />}
      <span className="select-setting-container">
        <select
          name={name}
          className="mg-custom-select"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        >
          {options.map((option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))}
        </select>
      </span>
      {description && (
        <small className="toggle-switch-description">
          {description}
          {details && <DetailsPill title={label} details={details} />}
        </small>
      )}
      {children}
    </div>
  );
};

SelectSetting.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  helpTitle: PropTypes.string,
  helpDescription: PropTypes.string,
  disabled: PropTypes.bool,
  description: PropTypes.string,
  /** Long-form copy behind a pill on the description line, as markdown — see src/content/details */
  details: PropTypes.string,
  children: PropTypes.node,
};

export default SelectSetting;
